import { render } from "./ApEditBlock.vue?vue&type=template&id=bca53e9a&scoped=true&ts=true"
import script from "./ApEditBlock.vue?vue&type=script&lang=ts"
export * from "./ApEditBlock.vue?vue&type=script&lang=ts"

import "./ApEditBlock.vue?vue&type=style&index=0&id=bca53e9a&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca53e9a"]])

export default __exports__